import { Text } from '@oneaudi/unified-web-components';
import {
	ButtonTabsContainer,
	StyledButtonTab,
} from '~/app/compositions/sidebar/interior-packages/styles/button-tabs-style';
import { DATA_TEST_ID } from '~/test/data-test-id';

interface ButtonTabsProps {
	tabs: { value: string; label: string }[];
	selectedTab: string;
	setSelectedTab: (tab: string) => void;
}

export const ButtonTabs = ({ tabs, selectedTab, setSelectedTab }: ButtonTabsProps) => {
	return (
		<>
			{tabs.length > 1 ? (
				<ButtonTabsContainer className="button-tabs-container">
					{tabs.map((tab) => (
						<ButtonTab
							isActive={tab.value === selectedTab}
							label={tab.label}
							onClick={() => setSelectedTab(tab.value)}
							key={tab.value}
						/>
					))}
				</ButtonTabsContainer>
			) : (
				<></>
			)}
		</>
	);
};

interface ButtonTabProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	label: string;
	isActive: boolean;
}
const ButtonTab = ({ label, isActive, ...buttonProps }: ButtonTabProps) => {
	return (
		<StyledButtonTab data-testid={DATA_TEST_ID.SELECTION_TAB_BUTTON} $isActive={isActive} {...buttonProps}>
			<Text className="label" tag="p" variant={{ type: 'copy', order: '2', style: 'normal' }}>
				{label}
			</Text>
		</StyledButtonTab>
	);
};
